import { AccountButton } from "@latticexyz/entrykit/internal";
import { JoinButton } from "./JoinButton";

export const Home = () => {
  return (
    <>
      <div className="grid place-items-center content-center p-8 space-y-10 h-screen overflow-auto">
        <img src="/doom-on-quarry.svg" className="mb-4 max-h-96" alt="Doom on Quarry" />
        <p className="text-lg text-center max-w-lg">
          This is a DOOM WebAssembly port with multiplayer support running fully onchain using{" "}
          <a href="https://lattice.xyz">Quarry</a> and <a href="https://mud.dev">MUD</a>. There are no optimistic
          updates, state updates are sent as transactions in real time.
        </p>
        <JoinButton />
      </div>
      <div className="absolute top-4 right-4">
        <AccountButton />
      </div>
    </>
  );
};
